import {
    OBTENER_DOWNLINK,
    DOWNLINK_ERROR,
    DOWNLINK_OK,
    ENVIAR_MENSAJE
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_DOWNLINK:
            return {
                ...state,
                downlink: action.payload
            }
        case ENVIAR_MENSAJE:
            return {
                ...state,
                downlink: action.payload
            }
        case DOWNLINK_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case DOWNLINK_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        default:
            return state;
    }
}